import {Injectable} from '@angular/core';
import {BehaviorSubject, combineLatest, distinctUntilChanged} from 'rxjs';
import {filter} from 'rxjs/operators';
import {AuthUntilUserRoleService} from './auth-until-user-role.service';
import {NavigationEnd, Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ImpersonationService {
    private learnerIdSubject = new BehaviorSubject<string | undefined>(undefined);
    public impersonatedLearnerId$ = this.learnerIdSubject.asObservable().pipe(distinctUntilChanged());

    private isImpersonationModeSubject = new BehaviorSubject<boolean>(false);
    public isImpersonationMode$ = this.isImpersonationModeSubject.asObservable().pipe(distinctUntilChanged());

    constructor(private router: Router,
                private authUntilUserRoleService: AuthUntilUserRoleService) {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            this.updateLearnerIdFromUrl();
        });

        this.updateLearnerIdFromUrl();

        combineLatest([this.authUntilUserRoleService.assertAdmin(), this.impersonatedLearnerId$]).subscribe(([isAdmin, learnerId]) => {
            const isImpersonationMode = isAdmin && learnerId !== undefined;
            this.isImpersonationModeSubject.next(isImpersonationMode);
        });
    }

    private updateLearnerIdFromUrl(): void {
        const tree = this.router.parseUrl(this.router.url);
        const learnerId = tree.queryParams['learnerid'] ?? undefined;
        this.learnerIdSubject.next(learnerId);

    }

}
